import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import CommWhatsAppPageShell from './CommWhatsAppPageShell'
import WhatsAppQueuePanel from '../whatsapp/WhatsAppQueuePanel'
import '../../css/Admin_css/admin-customize.css'

// Created By Cursor — dedicated Queue page (CRM-style separate route)
const CommWhatsAppQueue = () => {
  const token = localStorage.getItem('token')
  const [loggedIn] = useState(!!token)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (!loggedIn) return <Redirect to="/Login" />

  return (
    <CommWhatsAppPageShell
      title="WhatsApp Queue"
      breadcrumb="Queue"
      activeNav="queue"
    >
      <WhatsAppQueuePanel />
    </CommWhatsAppPageShell>
  )
}

export default CommWhatsAppQueue
